/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* About page: lift the "Skills" section (a Heading 2 followed by up to 7
   Image cards) out of the normal content flow and into the floating card
   cluster in the hero (page-about.hbs). An image's caption becomes the
   card label; "Label - Sublabel" in the caption adds a second line. */
(function () {
    const content = document.querySelector('.gh-about-content');
    const stage = document.querySelector('.gh-about-stage');
    const cluster = document.querySelector('.gh-about-cluster');
    if (!content || !stage || !cluster) return;

    const depths = [
        '-1.0,-0.7,0.9',
        '-0.6,-1.1,0.6',
        '-1.3,0.5,1.1',
        '1.6,1.2,-1.4',
        '1.1,0.9,-0.9',
        '0.7,1.4,-0.6',
        '-0.9,0.9,0.7'
    ];

    const heading = Array.from(content.children).find(function (node) {
        return node.tagName === 'H2' && node.textContent.trim().toLowerCase() === 'skills';
    });

    if (!heading) {
        stage.style.display = 'none';
        return;
    }

    const toRemove = [heading];
    const images = [];
    let node = heading.nextElementSibling;

    while (node && node.tagName !== 'H2') {
        const next = node.nextElementSibling;
        const img = node.querySelector('img');

        if (img) {
            const caption = node.querySelector('figcaption');
            images.push({
                src: img.getAttribute('src'),
                alt: img.getAttribute('alt') || '',
                caption: caption ? caption.textContent.trim() : ''
            });
        }

        toRemove.push(node);
        node = next;
    }

    toRemove.forEach(function (el) {
        el.remove();
    });

    if (!images.length) {
        stage.style.display = 'none';
        return;
    }

    images.slice(0, 7).forEach(function (image, i) {
        const parts = image.caption.split(/\s+-\s+/);
        const label = (parts[0] || image.alt || '').trim();
        const sublabel = (parts[1] || '').trim();

        const card = document.createElement('div');
        card.className = 'gh-about-skill slot-' + (i + 1);
        card.setAttribute('data-depth', depths[i] || '0,0,0');

        const sheen = document.createElement('span');
        sheen.className = 'gh-about-skill-sheen';
        sheen.setAttribute('aria-hidden', 'true');
        card.appendChild(sheen);

        const tile = document.createElement('div');
        tile.className = 'gh-about-icon-tile';
        const tileImg = document.createElement('img');
        tileImg.src = image.src;
        tileImg.alt = '';
        tile.appendChild(tileImg);
        card.appendChild(tile);

        if (sublabel) {
            const text = document.createElement('div');
            text.className = 'gh-about-skill-text';

            const labelEl = document.createElement('span');
            labelEl.className = 'gh-about-skill-label';
            labelEl.textContent = label;
            text.appendChild(labelEl);

            const subEl = document.createElement('span');
            subEl.className = 'gh-about-skill-sublabel';
            subEl.textContent = sublabel;
            text.appendChild(subEl);

            card.appendChild(text);
        } else {
            const labelEl = document.createElement('span');
            labelEl.className = 'gh-about-skill-label';
            labelEl.textContent = label;
            card.appendChild(labelEl);
        }

        cluster.appendChild(card);
    });
})();

/* About page: group each Heading-2-delimited block of the page content
   into its own glass card (page-about.hbs) */
(function () {
    const content = document.querySelector('.gh-about-content');
    if (!content) return;

    const sections = [];
    let current = null;

    Array.from(content.children).forEach(function (node) {
        if (node.tagName === 'H2') {
            current = {heading: node, body: []};
            sections.push(current);
        } else if (current) {
            current.body.push(node);
        }
    });

    sections.forEach(function (section) {
        const wrap = document.createElement('div');
        wrap.className = 'gh-about-section';

        const headingRow = document.createElement('div');
        headingRow.className = 'gh-about-section-heading';
        headingRow.appendChild(section.heading);

        const card = document.createElement('div');
        card.className = 'gh-about-section-card';
        section.body.forEach(function (node) {
            card.appendChild(node);
        });

        wrap.appendChild(headingRow);
        wrap.appendChild(card);
        content.appendChild(wrap);
    });
})();

/* About page: turn runs of Image cards into a stacked photo deck that fans
   out on hover and opens a lightbox on click (page-about.hbs).
   - Any run of 3+ consecutive Image cards inside the page content becomes a
     deck, right where it sits in the text.
   - A Heading 2 titled "Travel"/"Travels" is only a marker: its content is
     merged into the previous section card (no extra card, no cut in the
     document) and every Image card in it becomes a deck, whatever the count.
   An image's caption is the label shown on its photo. */
(function () {
    const content = document.querySelector('.gh-about-content');
    if (!content) return;

    const marked = new Set();
    const travel = Array.from(content.querySelectorAll('.gh-about-section')).find(function (el) {
        const h2 = el.querySelector('.gh-about-section-heading h2');
        return h2 && /^travels?$/i.test(h2.textContent.trim());
    });

    if (travel) {
        const travelCard = travel.querySelector('.gh-about-section-card');
        const previous = travel.previousElementSibling;
        const target = previous && previous.querySelector('.gh-about-section-card');

        if (target) {
            Array.from(travelCard.children).forEach(function (node) {
                marked.add(node);
                target.appendChild(node);
            });
            travel.remove();
        } else {
            Array.from(travelCard.children).forEach(function (node) {
                marked.add(node);
            });
        }
    }

    function isPhoto(node) {
        return node.tagName === 'FIGURE' && node.classList.contains('kg-image-card') && !!node.querySelector('img');
    }

    function readPhoto(node) {
        const img = node.querySelector('img');
        const caption = node.querySelector('figcaption');
        return {
            src: img.getAttribute('src'),
            srcset: img.getAttribute('srcset'),
            w: parseInt(img.getAttribute('width'), 10) || 1600,
            h: parseInt(img.getAttribute('height'), 10) || 1200,
            label: caption ? caption.textContent.trim() : (img.getAttribute('alt') || '').trim()
        };
    }

    function rand(min, max) {
        return min + Math.random() * (max - min);
    }

    function openLightbox(photos, index, fan) {
        if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return;
        const pswpElement = document.querySelector('.pswp');
        if (!pswpElement) return;

        const thumbs = Array.from(fan.querySelectorAll('img'));
        const items = photos.map(function (photo, i) {
            return {
                src: photo.src,
                msrc: photo.src,
                w: photo.w,
                h: photo.h,
                title: photo.label,
                el: thumbs[i]
            };
        });

        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            bgOpacity: 0.9,
            closeOnScroll: true,
            fullscreenEl: false,
            history: false,
            index: index,
            shareEl: false,
            zoomEl: false,
            getThumbBoundsFn: function (i) {
                const rect = items[i].el.getBoundingClientRect();
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            }
        });
        gallery.init();
    }

    function buildDeck(nodes) {
        const photos = nodes.map(readPhoto);
        const mid = (photos.length - 1) / 2;
        const touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;

        const fan = document.createElement('div');
        fan.className = 'gh-about-fan';
        fan.setAttribute('role', 'group');
        fan.setAttribute('aria-label', 'Photos');
        fan.style.setProperty('--n', photos.length);

        photos.forEach(function (photo, i) {
            const off = i - mid;
            const item = document.createElement('figure');
            item.className = 'gh-about-fan-item';
            item.setAttribute('role', 'button');
            item.setAttribute('tabindex', '0');
            item.setAttribute('aria-label', photo.label || 'Open photo');
            item.style.setProperty('--off', off);
            item.style.setProperty('--abs', Math.abs(off));
            item.style.setProperty('--z', Math.round(photos.length - Math.abs(off)));
            item.style.setProperty('--rot', rand(-11, 11).toFixed(2) + 'deg');
            item.style.setProperty('--dx', rand(-14, 14).toFixed(1) + 'px');
            item.style.setProperty('--dy', rand(-8, 8).toFixed(1) + 'px');
            item.style.setProperty('--jit', rand(-1.5, 1.5).toFixed(2) + 'deg');

            const img = document.createElement('img');
            img.src = photo.src;
            if (photo.srcset) img.srcset = photo.srcset;
            img.alt = photo.label;
            img.loading = 'lazy';
            item.appendChild(img);

            if (photo.label) {
                const cap = document.createElement('figcaption');
                cap.textContent = photo.label;
                item.appendChild(cap);
            }

            function activate(e) {
                e.stopPropagation();
                if (touchOnly && !fan.classList.contains('is-open')) {
                    fan.classList.add('is-open');
                    return;
                }
                openLightbox(photos, i, fan);
            }

            item.addEventListener('click', activate);
            item.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    activate(e);
                }
            });

            fan.appendChild(item);
        });

        if (touchOnly) {
            fan.addEventListener('click', function () {
                fan.classList.toggle('is-open');
            });
        }

        return fan;
    }

    content.querySelectorAll('.gh-about-section-card').forEach(function (card) {
        const runs = [];
        let run = [];

        Array.from(card.children).forEach(function (node) {
            if (isPhoto(node)) {
                run.push(node);
            } else {
                if (run.length) runs.push(run);
                run = [];
            }
        });
        if (run.length) runs.push(run);

        runs.forEach(function (nodes) {
            const isTravel = nodes.some(function (n) {
                return marked.has(n);
            });
            if (nodes.length < 3 && !isTravel) return;

            for (let start = 0; start < nodes.length; start += 8) {
                const chunk = nodes.slice(start, start + 8);
                card.insertBefore(buildDeck(chunk), chunk[0]);
            }
            nodes.forEach(function (n) {
                n.remove();
            });
        });
    });
})();

/* About page: subtle pointer parallax on the floating skill cards
   (page-about.hbs). Off for touch pointers and prefers-reduced-motion. */
(function () {
    const stage = document.querySelector('[data-about-parallax]');
    if (!stage) return;

    const cards = Array.from(stage.querySelectorAll('.gh-about-skill'));
    if (!cards.length) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (reduceMotion || isTouch) return;

    const amplitude = 10;
    let raf = null;

    // Once a card gets an individual rotateX/rotateY inside the cluster's
    // preserve-3d scene, browsers stack overlapping cards by true 3D depth
    // instead of CSS z-index — and since every card sits on the same Z=0
    // plane, that depth is decided only by the tiny, constantly-changing
    // tilt, so which card wins flickers as the pointer moves ("cutting").
    // Baking in a fixed translateZ per card (matching the same front-to-back
    // order the CSS z-index already expresses) gives the 3D scene a real,
    // stable depth to sort by.
    const zBySlot = {1: 0, 2: 0, 3: 0, 4: 28, 5: 18, 6: 9, 7: 0};

    function apply(mx, my) {
        cards.forEach(function (card) {
            const depth = (card.getAttribute('data-depth') || '0,0,0').split(',').map(Number);
            const slotMatch = card.className.match(/slot-(\d+)/);
            const z = slotMatch ? (zBySlot[slotMatch[1]] || 0) : 0;
            const x = mx * amplitude * depth[0];
            const y = my * amplitude * depth[1];
            const rx = -my * (amplitude * 0.22) * depth[2];
            const ry = mx * (amplitude * 0.22) * depth[2];
            card.style.transform = 'translate3d(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px, ' + z + 'px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        });
    }

    apply(0, 0);

    stage.addEventListener('mousemove', function (e) {
        const rect = stage.getBoundingClientRect();
        const mx = (e.clientX - rect.left) / rect.width - 0.5;
        const my = (e.clientY - rect.top) / rect.height - 0.5;

        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
            apply(mx, my);
        });
    });

    stage.addEventListener('mouseleave', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
            apply(0, 0);
        });
    });
})();

/* Homepage hero: turn the comma-separated "Core stack" theme setting into chips */
(function () {
    document.querySelectorAll('.gh-hero-skills[data-stack]').forEach(function (box) {
        const items = box.getAttribute('data-stack').split(/[,\n]/).map(function (t) {
            return t.trim();
        }).filter(Boolean);

        box.textContent = '';
        items.forEach(function (text) {
            const chip = document.createElement('span');
            chip.className = 'gh-chip';
            chip.textContent = text;
            box.appendChild(chip);
        });
    });
})();
